import console from './console';
import protocol from './protocol';
import consoleReportMonitoringCenter from './monitoringCenterReport';
import whatsapp from 'views/screens/WhatsApp/sidebarLayout';

const monitoringCenterChildren = [...console, ...protocol, ...consoleReportMonitoringCenter, ...whatsapp];

export default [
  {
    header: 'sidebar.general',
    iconName: 'Target',
    children: monitoringCenterChildren
  },
  ...monitoringCenterChildren
];
